import React from 'react';
import './DrawerMenu.scss';
import Close from '../../UI/Icons/Close';
import { COLORS } from '../../../constants/colors';
import DesktopNav from '../DesktopNav/DesktopNav';

/**
 * Renders Desktop Menu
 * @param {MutableRefObject} drawer - Drawer reference used for scroll locking
 * @param {Function} toggleMenuItems - Function reference to toggle children menu items under a specific parent
 * @param {Function} handleToggle - Function reference to handle setting the state of menu and scroll lock
 * @param {Boolean} menuOpen - Global state in Header.js for menu open/close
 * @param {Array} menuItems - Parent menu items
 * @param {Array} linkItems - Children menu items of parents
 * @returns {*|JSX.Element}
 * @constructor
 */
const DrawerMenu = ({ drawer, toggleMenuItems, handleToggle, menuOpen, menuItems, linkItems }) => (
  <div ref={drawer} className={`c-drawer-menu ${menuOpen ? 'active' : ''}`}>
    <div className={`c-drawer-menu__wrapper ${menuOpen ? 'active' : ''}`}>
      <div className="c-drawer-menu__header">
        <div className="c-drawer-menu__header-links">
          <DesktopNav
            drawer={drawer}
            linkItems={linkItems}
            classes="body-2 color-gray"
            menuItems={menuItems}
            onClickAction={toggleMenuItems}
          />
        </div>
        <button
          className="c-drawer-menu__header-close-btn"
          onClick={handleToggle}
          aria-label="Close Menu"
        >
          <Close color={COLORS.black} />
        </button>
      </div>
      <div className="c-drawer-menu__links">
        <ul className="c-drawer-menu__link-list">
          {menuItems.map((menu) => {
            if (menu.isExpanded) {
              return menu.links.map((link) => (
                <li className="c-drawer-menu__link-list-item">
                  <a className="c-drawer-menu__link h3-roobert color-gray" href={link.url}>
                    {link.title}
                  </a>
                </li>
              ));
            }
          })}
        </ul>
      </div>
    </div>
    <div onClick={handleToggle} className={`c-drawer-menu__overlay ${menuOpen ? 'active' : ''}`} />
  </div>
);

export default DrawerMenu;
